import { useNavigate } from "react-router-dom";
import StepShell from "../components/StepShell";
import AyupathCard from "../components/AyupathCard";
import PrimaryButton from "../components/PrimaryButton";
import SecondaryButton from "../components/SecondaryButton";
import { useForm } from "../context/FormContext";
import { track } from "../utils/analytics";
import useEnterToContinue from "../hooks/useEnterToContinue";

const OPTIONS = [
  ["identity", "Identity / next chapter"],
  ["work", "Work / career"],
  ["relationships", "Relationships / boundaries"],
  ["confidence", "Confidence / purpose"],
  ["energy", "Energy / priorities"],
  ["other", "Something else"],
];

export default function StepFocus() {
  const navigate = useNavigate();
  const { formData, setFormData } = useForm();

  function continueToEmail(skip = false) {
    if (skip) setFormData({ ...formData, focusArea: "" });
    track("focus_area_selected", { selected: !skip && !!formData.focusArea });
    navigate("/email");
  }

  useEnterToContinue(() => continueToEmail());

  return (
    <StepShell step={5} totalSteps={6} title="Your next chapter">
      <AyupathCard>
        <div className="space-y-5">
          <fieldset className="space-y-3">
            <legend className="text-2xl font-semibold text-gray-900">
              What would you most like clarity on?
            </legend>
            <p className="text-gray-600">Optional. No personal backstory needed.</p>
            {OPTIONS.map(([value, label]) => (
              <label key={value} className="flex items-center gap-3 rounded-2xl border border-gray-300 p-4 text-gray-900 cursor-pointer focus-within:ring-2 focus-within:ring-orange-500">
                <input type="radio" name="focus" value={value}
                  checked={formData.focusArea === value}
                  onChange={() => setFormData({ ...formData, focusArea: value })}
                  className="h-5 w-5 accent-orange-600" />
                {label}
              </label>
            ))}
          </fieldset>
          <PrimaryButton onClick={() => continueToEmail()}>Next</PrimaryButton>
          <div className="text-center">
            <SecondaryButton onClick={() => continueToEmail(true)}>Skip for now</SecondaryButton>
          </div>
        </div>
      </AyupathCard>
    </StepShell>
  );
}